var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.75C20 3.75 23.3052 3.75 26.3256 5.02752C26.3256 5.02752 29.242 6.26105 31.4905 8.50951C31.4905 8.50951 33.739 10.758 34.9725 13.6744C34.9725 13.6744 36.25 16.6948 36.25 20C36.25 20 36.25 23.3052 34.9725 26.3256C34.9725 26.3256 33.739 29.242 31.4905 31.4905C31.4905 31.4905 29.242 33.7389 26.3256 34.9725C26.3256 34.9725 23.3052 36.25 20 36.25C20 36.25 16.6948 36.25 13.6744 34.9725C13.6744 34.9725 10.758 33.7389 8.50952 31.4905C8.50952 31.4905 6.26105 29.242 5.02752 26.3256C5.02752 26.3256 3.75 23.3052 3.75 20C3.75 20 3.75 16.6948 5.02752 13.6744C5.02752 13.6744 6.26106 10.758 8.50952 8.50951C8.50952 8.50951 10.758 6.26106 13.6744 5.02752C13.6744 5.02752 16.6948 3.75 20 3.75ZM20 6.25C20 6.25 17.2017 6.25 14.6483 7.33003C14.6483 7.33003 12.1809 8.37362 10.2773 10.2773C10.2773 10.2773 8.37362 12.1809 7.33003 14.6483C7.33003 14.6483 6.25 17.2017 6.25 20C6.25 20 6.25 22.7983 7.33003 25.3517C7.33003 25.3517 8.37362 27.8191 10.2773 29.7227C10.2773 29.7227 12.1809 31.6264 14.6483 32.67C14.6483 32.67 17.2017 33.75 20 33.75C20 33.75 22.7983 33.75 25.3517 32.67C25.3517 32.67 27.819 31.6264 29.7227 29.7227C29.7227 29.7227 31.6264 27.819 32.67 25.3517C32.67 25.3517 33.75 22.7982 33.75 20C33.75 20 33.75 17.2017 32.67 14.6483C32.67 14.6483 31.6264 12.1809 29.7227 10.2773C29.7227 10.2773 27.819 8.37361 25.3517 7.33003C25.3517 7.33003 22.7983 6.25 20 6.25Z",
    fill: "#F85640"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.5V21.25C18.75 21.9404 19.3096 22.5 20 22.5C20.6904 22.5 21.25 21.9404 21.25 21.25V12.5C21.25 11.8096 20.6904 11.25 20 11.25C19.3096 11.25 18.75 11.8096 18.75 12.5Z",
    fill: "#F85640"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 26.875C21.875 27.9105 21.0355 28.75 20 28.75C18.9645 28.75 18.125 27.9105 18.125 26.875C18.125 25.8395 18.9645 25 20 25C21.0355 25 21.875 25.8395 21.875 26.875Z",
    fill: "#F85640"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.8531753ddac2ab20934ea2df9e7bfc6e.svg";
export { ForwardRef as ReactComponent };